import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";
import { capitalizeFirstLetter } from 'components/JobApplication/Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepNine = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [details, setDetails] = useState(null);
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setDetails(storedData.screeningFurtherInformation || "");
        }
    }, []);

    const handleCapitalWord = (event) => {
        handleChangeData(capitalizeFirstLetter(event.target.value));
    };

    const validateForm = (details) => {
        const errors = {
            detail: isEmpty(details) && "Further information is required",
        }
        return errors;
    }

    const handleSubmit = async () => {
       
        try {
            const errors = validateForm(details);
            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HSInduction/SubmitScreeningFurtherInformation?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}&details=${details}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                });
                if (response.status === 200) {
                    handleNext(details);
                } else {
                    setAlert(CustomSweetAlert({
                        type: "error", title: "Error", message: `Error: Save step 9 failed`,
                        onConfirm: () => {
                            hideAlert();
                        }, showCancel: false
                    }));
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleChangeData = (v) => setDetails(v);
    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col md={12} className='text-start'></Col>
            <h5 className="mb-0" style={{ fontSize: "1.2rem" }}>Further Information</h5><br />
            <h5 className="mt-2">Please use this area to provide further details in relation to parts 4 - 7 on how the condition affects your day to day ability to undertake activities and how it affects your general wellbeing.</h5>
            <Form.Group>
                <Form.Control
                    className={errors.comment ? "form-control is-invalid" : "form-control"}
                    as="textarea" rows={5}
                    style={{
                        height: 'auto',
                    }}
                    onBlur={handleCapitalWord}
                    value={details}
                    onChange={(e) => handleChangeData(e.target.value)}
                ></Form.Control>
                        {errors.detail && <Form.Text className="text-danger"> <span className="star">*</span> {errors.detail} </Form.Text>}

            </Form.Group>
            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>
    );
};

export default StepNine;